import React from 'react'

import InnerBotAvatar from './InnerBotAvatar'

import BotMessage from '../BotMessage'

import { MzRoundedBox , MzText} from '../../components'

import chatScript from "../ChatScript.json"

import Functions from '../utils/Functions'

export default function SingleSelectionMessage({ message, isLastBotMessage,  setIsTyping, messages, setMessages, answers,setAnswers, urlBotImage }) {

    const [selectedClasses, setSelectedClasses] = React.useState({})

    function select(msg, opz, setMessages, setIsTyping) {

        const msgId = msg.id

        const newAnswers = { ...answers }
        newAnswers[msg.chiave_domanda] = opz.valore


        if(opz.tipoRicerca){
            newAnswers["tipoRicerca"] = opz.tipoRicerca
        }

        setAnswers(newAnswers)
        //            console.log(newAnswers)

        if (!selectedClasses[msgId]) {

            const newSelectedClasses = { ...selectedClasses }
            newSelectedClasses[msgId] = {}
            newSelectedClasses[msgId][opz.idOp] = 'selected'
            setSelectedClasses(newSelectedClasses)


            const next = Functions.getMessageById(opz.prossima)

            if (next) {
                setIsTyping(true)
                setTimeout(() => {
                    //debugger
                    setIsTyping(false)
                    setMessages((prevMessages) => [...prevMessages, next])
                }, 1000)
            }


        }
    }



    return (
        <div key={"bot" + message.id}>
            <div className='grid'>
                <InnerBotAvatar urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} />
                <div className='col-11'>
                    <BotMessage msg={message} isLastBotMessage={isLastBotMessage}></BotMessage>
                </div>
            </div>

            <div className="grid mb-3">
                <div className='col-11 col-offset-1'>
                    <div className="flex flex-wrap justify-content-start column-gap-4 row-gap-4 ml-3">
                        {message.opzioni.map((opz, index) => {

                            const opzione_container_class = selectedClasses[message.id] === undefined ? "opzione_container " : "opzione_container_disabled "
                            // console.log("Opzione id= " + opz.idOp + " opzione_container_class=" + opzione_container_class + " selectedClasses[message.id]=" + JSON.stringify(selectedClasses[message.id]))
                            return (

                                <div key={opz.idOp} className=" ">

                                    <MzRoundedBox onClick={() => select(message, opz, setMessages, setIsTyping)} className={"flex flex-column justify-content-center align-items-center " + opzione_container_class + selectedClasses[message.id]?.[opz.idOp]} >
                                        <MzText value={opz.testo}></MzText>
                                        <div  >
                                            <img style={{ width: "70px", margin:"5px" }} src={opz.img}></img>
                                        </div>
                                    </MzRoundedBox >


                                </div>

                            )
                        })}
                    </div>

                </div>
            </div>
        </div>
    )
}
